import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IDashboardCards } from "../../../Pages/AdminDashboard/IDashboard";

export const OverallActivityFilterSlice = createSlice({
  name: "OverallActivityFilter",
  initialState: {} as IReduxState<IDashboardCards>,
  reducers: {
    OverallActivityFilter: (state,_: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successOverallActivityFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureOverallActivityFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearOverallActivityFilter: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureOverallActivityFilter,
  successOverallActivityFilter,
  clearOverallActivityFilter,
  OverallActivityFilter,
} = OverallActivityFilterSlice.actions;

export default OverallActivityFilterSlice.reducer;
